import { render, staticRenderFns } from "./selectLiaison.vue?vue&type=template&id=1016c438&scoped=true&"
import script from "./selectLiaison.vue?vue&type=script&lang=js&"
export * from "./selectLiaison.vue?vue&type=script&lang=js&"
import style0 from "./selectLiaison.vue?vue&type=style&index=0&id=1016c438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1016c438",
  null
  
)

export default component.exports